import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { LoadingPane } from '@social-solutions/ssg-forms';
import * as formPermissionsHelpers from './form-permissions-helpers';

export class RequirePermissions extends Component {

  /** converts program enrollment into an ssg forms loading state */
  getLoadingState() {
    const { programEnrollment } = this.props;
    const { err, isFetching, enrollment } = programEnrollment || { err: null, isFetching: false, isValid: false, enrollment: null};
    return {
      isLoading: isFetching,
      data: enrollment,
      error: !!err ? {
        alertLevel: 'error',
        errorCode: err.errorCode,
        errorMessage: err.errorMessage
      } : null
    }
  }

render() {
    const { programEnrollment, siteId, programId, formId, requireAdd, requireView, requireEdit, children } = this.props;

    var permissions = formPermissionsHelpers.getPermissionsObject(programEnrollment, siteId, programId, formId);
    var hasPermission = permissions &&
                        (!requireAdd || permissions.addPerm) &&
                        (!requireView || permissions.viewPerm) &&
                        (!requireEdit || permissions.editPerm);
    return (
      <LoadingPane loadingState={this.getLoadingState()} loadingMessage="Loading Permissions">
        { hasPermission ? <div id='children'>{children}</div> : null}
      </LoadingPane>
    );
  }
}

RequirePermissions.propTypes = {
  programEnrollment: PropTypes.object.isRequired,
  siteId: PropTypes.string.isRequired,
  programId: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  requireAdd: PropTypes.bool,
  requireView: PropTypes.bool,
  requireEdit: PropTypes.bool,
};

const mapStateToProps = ({ programEnrollment }) => {
  return {
    programEnrollment,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequirePermissions);



// WEBPACK FOOTER //
// src/common/require-permissions.js